import React, {useEffect, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../../components/me-child-header'
import { action_fetch_redeem_coupon_list, setRedeemCouponList } from '../../../../../../store/actions/pages/customer'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../../hooks/common'
import MeLoading from '../../../components/loading'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { CouponList } from '../components/coupone-list'
import { fetchCustomerFeed, pointsCouponExchange } from '../../../../../../api'
import { Iconfont } from '../../../../../components/icon/iconfont'
import NormalConfigConfirm from '../../../../../components/alert/config-confirm'

const PointsTab = props => {
    useStyles(classes)
    const {feed} = props

    return (
        <div className={classes.PointsTab}>
            <div className={classes.TabBg}>
                <span><FormattedMessage id='my_points' defaultMessage={'My points'}/>: {feed?.points || 0}</span>
                <span className={classes.TabIcon}></span>
            </div>
        </div>
    )
}

const RedeemCouponsPage = props => {
    useStyles(classes)

    const pageCustomer = useSelector(state => state.pageCustomer)
    const { customer, redeemCouponList } = pageCustomer || {}

    const dispatch = useDispatch()
    const Intl = useIntl()
    const store = useStore()
    const params = useParams()
    const query = useQuery()

    const [showType, setShowType] = useState("redeem")
    const [loading, setLoading] = useState(true)
    const [feed, setFeed] = useState(null)

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!redeemCouponList || redeemCouponList?.length == 0){
                await RedeemCouponsPage.fetchData(store, params, query)
            }
		}
    }, [])

    useEffect(async () =>{
        if(customer?.id){
            let response = await fetchCustomerFeed(customer?.id);
            if(response?.code === 200 && response?.result){
                setFeed(response?.result);
            }
        }
    }, [customer?.id]);

    useEffect(() => {
        if(redeemCouponList){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[redeemCouponList])

    const redeemCouponHandle = (coupon) => {
        if(coupon?.points > feed?.points){
            NormalConfigConfirm({
                boxStyle:{
                    padding:"25px",
                },
                message:{
                    text: Intl.formatMessage({id: 'do_not_have_enough_points', defaultMessage: 'You do not have enough points to redeem this coupon.'}),
                    style:{
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                        lineHeight: 'normal',
                        color:'#222222',
                        textAlign: 'center'
                    },
                    html:false
                },
                btn1:{
                    text: Intl.formatMessage({id: 'confirm', defaultMessage:'Confirm'}),
                },
            })
            if(window.GeekoSensors){
                window.GeekoSensors.Track('ELClick', {
                    is_redeem:"点击Redeem按钮触发",
                    page_sort:"Me",
                    page_content:"Coupons",
                    fail_reason: 'You do not have enough points to redeem this coupon.',
                    coupon_type: coupon?.coupon?.name
                })
            }
        } else {
            NormalConfigConfirm({
                boxStyle:{
                    padding:"25px",
                },
                message:{
                    text: Intl.formatMessage({id: 'use_points_redeem_coupon', defaultMessage: `Do you want to use ${coupon?.points} points to redeem this coupon?`},{points: coupon?.points}),
                    style:{
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                        lineHeight: 'normal',
                        color:'#222222',
                        textAlign: 'center'
                    },
                    html:false
                },
                btn1:{
                    text: Intl.formatMessage({id: 'confirm', defaultMessage:'Confirm'}),
                    clickHandle: () => {
                        redeemPost(coupon)
                    }
                },
                btn2:{
                    text: Intl.formatMessage({id: 'cancel', defaultMessage:'Cancel'}),
                },
            })
        }
    }

    const redeemPost = (coupon) => {
        setLoading(true)
        pointsCouponExchange({id: coupon?.id}).then(res => {
            if(res?.code == 200){
                let list = [...redeemCouponList]
                list.forEach((l) => {
                    if(l?.id == coupon?.id){
                        l.status = 1
                    }
                })
                dispatch(setRedeemCouponList(list))
                setFeed({...feed, points: feed?.points - coupon?.points})
                if(window.GeekoSensors){
                    window.GeekoSensors.Track('ELClick', {
                        is_redeem:"点击Redeem按钮触发",
                        page_sort:"Me",
                        page_content:"Coupons",
                        is_success:true,
                        coupon_type:coupon.coupon.name
                    })
                }
                NormalConfigConfirm({
                    boxStyle:{
                        padding:"25px",
                    },
                    message:{
                        text: `<div>
                                <span class="iconfont" style="color: #ff8031;font-size: 60px">&#xe6b7;</span>
                                <br/><br/>
                                <p style="font-size:16px;font-family: Roboto-Bold">
                                    ${Intl.formatMessage({id: 'points_redeem_success', defaultMessage: 'Redemption successful!'})}
                                </p>
                                <br/>
                            </div>`,
                        html:true,
                        style:{
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            lineHeight: 'normal',
                            color:'#222222',
                            textAlign: 'center'
                        },
                    },
                    btn1:{
                        text: Intl.formatMessage({id: 'confirm', defaultMessage:'Confirm'}),
                        clickHandle: () => {
                            // window.location.href = '/'
                            window.location.href = '/'
                            return
                        }
                    },
                })
            } else {
                alert(res?.result || 'Error')
            }
            setLoading(false)
        }).catch(err => {
            setLoading(false)
            alert(err?.result || 'Error')
        })
    }


    return <div classes={classes.CouponsPage}>
        <div className={classes.CouponsHeader}>
            <MeChildHeader name={Intl.formatMessage({id:'redeem_coupon', defaultMessage:'Redeem Coupon'}) }/>            
            <PointsTab feed={feed}/>
        </div>

        <div>
            <CouponList
                showType={showType}
                list={redeemCouponList}
                loading={false}
                finished={true}
                redeemCoupon={coupon => redeemCouponHandle(coupon)}
                />
        </div>

        <MeLoading loading={loading} />
    </div>
}

RedeemCouponsPage.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_redeem_coupon_list(headers))
}

export default RedeemCouponsPage